import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const spotTaxHistorySchema = z.object({
  /** Record ID */
  id: z.string(),
  /** Coin */
  coin: z.string(),
  /** 税種別（例: Interest, Buy, Sell など） */
  spotTaxType: z.string(),
  /** 数量 */
  amount: decimalSchema,
  /** 手数料 */
  fee: decimalSchema,
  /** 残高 */
  balance: decimalSchema,
  /** タイムスタンプ（この記録が生成された時間） */
  ts: z.string().regex(/^\d+$/).transform(Number),
})

export const responseSchema = z.object({
  /** Response code, `00000` for success */
  code: z.string(),
  /** Response message, `success` for success */
  msg: z.string(),
  /** Request time in milliseconds */
  requestTime: z.number(),
  /** データ配列 */
  data: z.array(spotTaxHistorySchema),
})
